<template>
  <!--
    	作者：luoyiming
    	时间：2020-06-20
    	描述：diy组件-参数设置-轮播图
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
      <el-form-item label="轮播图显示：">
        <el-radio-group v-model="curItem.style.imgShape">
          <el-radio label="round">圆角带边距</el-radio>
          <el-radio label="square">直角不带边距</el-radio>
        </el-radio-group>
      </el-form-item>
      <!--      <el-form-item label="指示点形状：">-->
      <!--        <el-radio-group v-model="curItem.style.btnShape">-->
      <!--          <el-radio label="round">圆形</el-radio>-->
      <!--          <el-radio label="square">正方形</el-radio>-->
      <!--          <el-radio label="rectangle">长方形</el-radio>-->
      <!--        </el-radio-group>-->
      <!--      </el-form-item>-->
      <el-form-item label="图片宽度(px):">
        <el-input placeholder="请输入图片宽度" :value="curItem.style.imgShape=='square'?750:710" disabled></el-input>
      </el-form-item>
      <el-form-item label="图片高度(px):">
        <el-input placeholder="请输入图片高度" v-model="curItem.style.height"></el-input>
      </el-form-item>
      <el-form-item label="指示点颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.btnColor"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;"
                     @click.stop="$parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')">重置
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="背景颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.background"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;"
                     @click.stop="$parent.onEditorResetColor(curItem.style, 'background', '#ffffff')">重置
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="切换时间：">
        <el-input v-model="curItem.params.interval"></el-input>
        <p>轮播图自动切换的间隔时间，单位：毫秒</p>
      </el-form-item>
      <el-form-item label="图片：">
        <div class="param-img-item  d-s-c" :key="index" v-for="(imageSingle, index) in curItem.data">
          <div class="delete-box"><i class="el-icon-delete-solid"
                                     @click="$parent.onEditorDeleleData(index, selectedIndex)"></i></div>
          <div class="pic d-c-c"><img v-img-url="imageSingle.imgUrl" alt="" style="object-fit: contain;"
                                      @click="$parent.onEditorSelectImage(imageSingle, 'imgUrl')"></img></div>
          <div class="d-c-s d-c ml20" style="width: 70%">
            <div class="url-box">
              <span class="key-name">链接地址：</span>

            </div>
            <div class="url-box flex-1 d-s-c">
              <el-input v-model="imageSingle.name"></el-input>
              <el-button style="margin-left:20px;height: 32px" type="primary" @click="changeLink(index)">选择链接
              </el-button>
            </div>
          </div>
        </div>
        <div class="d-c-c">
          <el-button @click="$parent.onEditorAddData">添加一个</el-button>
        </div>
      </el-form-item>
    </el-form>
    <Setlink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset">选择链接</Setlink>
  </div>
</template>

<script>
import Setlink from '@/components/setlink/Setlink'

export default {
  components: {
    Setlink
  },
  data () {
    return {
      /*是否选择链接*/
      is_linkset: false,
      index: null
    }
  },
  props: ['curItem', 'selectedIndex'],
  watch: {
    'imgUrlHeight': {
      handler (n, o) {
        if (n != o) {
          let imgHeight = this.getImgHeight(n, this.curItem.style.imgShape == 'square' ? 750 : 710)
          this.curItem.style.height = imgHeight ? imgHeight : this.curItem.style.height
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    imgUrlHeight () {
      if (this.curItem.data.length > 0) {
        return this.curItem.data[0].imgUrl
      }

    }
  },
  methods: {
    /*选择链接*/
    changeLink (index) {
      this.is_linkset = true
      this.index = index
    },
    getImgHeight (src, screenWidth) {
      if (src && src.length > 0) {
        var img_url = src
        var img = new Image()
        img.src = img_url
        return Math.ceil(screenWidth / img.width * img.height)
      } else {
        return 0
      }

    },
    /*获取链接并关闭弹窗*/
    closeLinkset (e) {
      this.is_linkset = false
      if (e) {
        this.curItem.data[this.index].linkUrl = e.url
        this.curItem.data[this.index].name = '链接到' + ' ' + e.type + ' ' + e.name
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Banner.vue